import { Link } from 'react-router-dom';
import type { Article } from '@/types/content';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors flex flex-col">
      <Link to={`/article/${article.id}`} className="block cursor-pointer">
        <div className="w-full h-44 overflow-hidden bg-background-200">
          <img
            src={article.cover}
            alt={`${article.title} - 17爆料网独家爆料配图`}
            title={`${article.title} - 17爆料网`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-2 text-xs">
          <span className="px-2 py-0.5 rounded bg-accent-100 text-accent-800">{article.categoryName}</span>
          <span className="text-foreground-400">{article.date}</span>
        </div>
        <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug mb-2">
          <Link to={`/article/${article.id}`} className="hover:text-primary-700 transition-colors cursor-pointer">
            {article.title}
          </Link>
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">{article.excerpt}</p>
        <div className="mt-auto flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.views}
          </span>
        </div>
      </div>
    </article>
  );
}